import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  role: null,
  ispOwnerId: "",
  resellerId: "",
  userData: {},
  isFetching: false,
  error: false,
  accessToken: null,
  ispOwnerData: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logInStart: (state) => {
      state.isFetching = true;
    },
    // logInSuccess: (state, action) => {
    //   state.accessToken = action.payload?.access.token;
    //   state.isFetching = false;
    //   state.currentUser = action.payload;
    //   localStorage.setItem("tokenUsr", JSON.stringify(action.payload.user));
    //   state.role = action.payload?.user.role;
    //   action.payload?.user.role === "ispOwner"
    //     ? (state.ispOwnerId = action.payload?.ispOwner?.id) &&
    //       (state.userData = action.payload?.ispOwner)
    //     : action.payload?.user.role === "manager"
    //     ? (state.ispOwnerId = action.payload.manager.ispOwner) &&
    //       (state.userData = action.payload?.manager)
    //     : action.payload?.user.role === "collector"
    //     ? (state.userData = action.payload?.collector) &&
    //       (state.ispOwnerId = action.payload.collector.ispOwner)
    //     : action.payload?.user.role === "reseller"
    //     ? (state.ispOwnerId = action.payload?.reseller?.ispOwner) &&
    //       (state.userData = action.payload?.reseller)
    //     : action.payload?.user.role === "admin"
    //     ? (state.userData = action.payload?.admin)
    //     : (state.ispOwnerId = "");
    // },
    logInSuccess: (state, action) => {
      const payload = action.payload || {};
      const { access, user } = payload;
      const role = user?.role;

      state.accessToken = access?.token ?? "";
      state.isFetching = false;
      state.currentUser = payload;
      state.role = role ?? "";

      localStorage.setItem("tokenUsr", JSON.stringify(user ?? {}));

      const roleConfig = {
        ispOwner: () => ({
          ispOwnerId: payload.ispOwner?.id ?? "",
          userData: payload.ispOwner,
        }),
        manager: () => ({
          ispOwnerId: payload.manager?.ispOwner ?? "",
          userData: payload.manager,
        }),
        collector: () => ({
          ispOwnerId: payload.collector?.ispOwner ?? "",
          userData: payload.collector,
          ...(payload.collector?.reseller && {
            resellerId: payload.collector?.reseller,
          }),
        }),
        reseller: () => ({
          ispOwnerId: payload.reseller?.ispOwner ?? "",
          userData: payload.reseller,
          resellerId: payload.reseller?.id ?? "",
        }),
        admin: () => ({
          ispOwnerId: "",
          userData: payload.admin,
        }),
      };

      const getData =
        roleConfig[role] || (() => ({ ispOwnerId: "", resellerId: "" }));

      const { ispOwnerId, resellerId, userData } = getData();

      state.ispOwnerId = ispOwnerId;
      state.resellerId = resellerId;
      state.userData = userData;
    },
    loginFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    updateProfile: (state, action) => {
      if (state.role === "ispOwner") {
        state.currentUser.ispOwner = action.payload;
        state.userData = action.payload;
      } else if (state.role === "manager") {
        state.currentUser.manager = action.payload;
        state.userData = action.payload;
      } else if (state.role === "collector") {
        state.currentUser.collector = action.payload;
        state.userData = action.payload;
      }
    },
    smsSettingUpdateIsp: (state, action) => {
      if (state.role === "ispOwner") {
        state.userData = action.payload;
      } else if (state.role === "manager") {
        // state.currentUser.manager = action.payload;
        // state.userData = action.payload;
      } else if (state.role === "reseller") {
        state.currentUser.reseller = action.payload;
      }
    },
    updateTokenSuccess: (state, action) => {
      state.accessToken = action.payload;
    },
    setBpsetting: (state, action) => {
      state.userData = {
        ...state.userData,
        bpSettings: action.payload,
      };
    },

    setIspOwnerData: (state, action) => {
      state.ispOwnerData = action.payload;
    },
    updateUserData: (state, action) => {
      state.userData = action.payload;
      if (state.role === "ispOwner") {
        state.currentUser.ispOwner = action.payload;
      } else if (state.role === "reseller") {
        state.currentUser.reseller = action.payload;
      } else if (state.role === "manager") {
        state.currentUser.manager = action.payload;
      } else if (state.role === "collector") {
        state.currentUser.collector = action.payload;
      }
    },

    logOut: (state) => {
      state.currentUser = null;
      state.accessToken = null;
      state.role = null;
      state.ispOwnerId = "";
      state.userData = {};
    },
  },
});

export const {
  updateTokenSuccess,
  updateProfile,
  logInStart,
  logInSuccess,
  loginFailure,
  logOut,
  setBpsetting,
  setIspOwnerData,
  smsSettingUpdateIsp,
  updateUserData,
} = authSlice.actions;

export default authSlice.reducer;
